import { render } from "./JourFerieModal.vue?vue&type=template&id=10b87d10&scoped=true&ts=true"
import script from "./JourFerieModal.vue?vue&type=script&lang=ts"
export * from "./JourFerieModal.vue?vue&type=script&lang=ts"

import "./JourFerieModal.vue?vue&type=style&index=0&id=10b87d10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b87d10"]])

export default __exports__